"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ROUTE = void 0;
exports.ROUTE = "secret-wasm";
//# sourceMappingURL=constants.js.map